import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const About = () => {
  const { t } = useLanguage();
  const a = t.home.about;
  return (
    <section id="about" className="relative bg-ink py-28 md:py-36 px-6 md:px-12 lg:px-20 border-t border-white/10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
        className="max-w-4xl"
      >
        <p className="font-mono text-brand-cyan text-xs tracking-[0.25em] mb-4" data-testid="about-eyebrow">
          {a.eyebrow}
        </p>
        <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white mb-10" data-testid="about-title">
          {a.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <p className="font-manrope text-white/60 leading-relaxed">{a.paragraph1}</p>
          <p className="font-manrope text-white/60 leading-relaxed">{a.paragraph2}</p>
        </div>
      </motion.div>
    </section>
  );
};
